import React, { useState } from "react";
import axios from "axios";
import HourlyForecast from "./HourlyForecast";
import CurrentWeatherInfo from "./CurrentWeatherInfo";

import "./CurrentWeather.css";

export default function CurrentWeather(props) {
  const [city, setCity] = useState(props.defaultCity);
  const [weatherData, setWeatherData] = useState({ ready: false });
  function handleResponse(response) {
    setWeatherData({
      ready: true,
      temperature: response.data.main.temp,
      humidity: response.data.main.humidity,
      date: new Date(response.data.dt * 1000),
      description: response.data.weather[0].description,
      icon: response.data.weather[0].icon,
      wind: response.data.wind.speed,
      city: response.data.name,
    });
  }

  function search() {
    const apiKey = "3699a6fe3348afa86b71f2515e86a04b";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="CurrentWeather">
        <nav className="navbar navbar-light bg-light">
          <form className="form-inline" onSubmit={handleSubmit}>
            <input
              className="form-control mr-sm-2"
              type="search"
              placeholder="Search City"
              aria-label="Search"
              autoFocus="on"
              onChange={handleCityChange}
            />
            <button
              className="btn btn-primary my-2 my-sm-0 search"
              type="submit"
            >
              Search
            </button>
          </form>
        </nav>
        <CurrentWeatherInfo data={weatherData} />
        <HourlyForecast city={weatherData.city} />
      </div>
    );
  } else {
    search();
    return "Loding...";
  }
}
